import NGText from '@NGComponents/NGText';
import Flex from 'src/styles/layouts/Flex';
import styled from 'styled-components';

export const FlexEx = styled(Flex)`
	border-left: 2px solid #393b3b;
`;

export const NGTextEx = styled(NGText)`
	& > .katex > * {
		color: ${(props) => props.theme.colors.gold};
	}
`;
